<template>
  <a-modal
          title="质检机构双随机任务"
          okText="确认"
          cancelText="取消"
          width="800px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="请选择执行日期" prop="checkDate">
            <a-ext-data-picker v-model="formState.checkDate"></a-ext-data-picker>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="请选择机构名称" prop="orgId">
            <a-ext-gov-select v-model="formState.orgId"></a-ext-gov-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="请选择小组长" prop="leader">
            <a-ext-zhuan-jia-select v-model="formState.leader"></a-ext-zhuan-jia-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="请选择小组组员" prop="member">
            <a-ext-v-for-select-member v-model="formState.member"></a-ext-v-for-select-member>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="请选择小组组员" prop="otherMember">
            <a-ext-v-for-input-member v-model="formState.otherMember"></a-ext-v-for-input-member>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>

  </a-modal>
</template>

<script>

import AExtGovSelect from '../../../components/AntDesignExt/All/AExtGovSelect'
import AExtZhuanJiaSelect from '../../../components/AntDesignExt/All/AExtZhuanJiaSelect'
import AExtVForSelectMember from '../../../components/AntDesignExt/All/AExtVForSelectMember'
import AExtVForInputMember from '../../../components/AntDesignExt/All/AExtVForInputMember'
import AExtDataPicker from '../../../components/AntDesignExt/All/AExtDataPicker'
import {addorUpdateDbRandom as saveApi,getDbRandomById as initApi} from '../../../api/api'
import {FormRules} from 'antd-form-rules';
export default {
    name: "FormModel",
    components:{
        AExtGovSelect,AExtZhuanJiaSelect,AExtVForSelectMember,AExtVForInputMember,AExtDataPicker},
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        param:{
            type:Object,
            default: ()=>{
                return {}
            }
        }
    },
    data() {
        return {
            confirmLoading: false,
            formState: {

            },
            rules: {
                orgId: FormRules.withName('请选择被监测机构名称').isRequired().create(),
                leader: FormRules.withName('请选择小组长').isRequired().create(),
                memeber: FormRules.withName('请选择小组组员').isRequired().create(),
                otherMember: FormRules.withName('请选择小组组员').isRequired().create(),
            },

        };
    },
    created(){
        this.initForm();
    },
    methods: {
        initForm(){
            if(this.param.id) {
                this.confirmLoading = true;
                initApi(this.param).then((result => {
                    this.formState = result.data.data;
                    this.confirmLoading = false;
                })).catch(() => {
                    this.confirmLoading = false;
                });
            }
        },
        handleOk(e) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    saveApi(this.formState).then((result=>{
                        this.confirmLoading = false;
                        this.$emit("addDbRandomClose",true)
                        this.$emit("update:visible",false)
                    })).catch(()=>{
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.$emit("update:visible",false)
        },

    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body{
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>